// components/settings
// форма с настройками аккауна

import template from './template.jade'
import style    from './style.scss'
import Store    from 'Store'
import Input    from 'lib/CurrentInput'

var name = 'settings'
var url  = 'api/settings'
const store = new Store(name)
var pattern = /[^0-9]/g

Input(jQuery)

export default {

  name: name,
  template: template({style: style}),

  data: () => ({
      name: name,
      url: url,
      show: true,
  }),

  ready() {
    // привязываем паттерн ввода только цифры к полю
    $('input[type="tel"]').currentInput({ pattern: pattern })

    this.$set('data', store.$get(this) )
  },

  watch: {
    data() {
      this.$set('form', this.data)
    }
  },

  methods: {
      // отправим форму
      submit(e) {
        e.preventDefault()
        var data = $(this.$$.form).serializeArray()
        this.$set('data', data)
        store.$save(this)
      },
  },
}



/** WEBPACK FOOTER **
 ** ./src/js/components/settings/index.js
 **/